import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';
import { AQISensor } from 'features/aqiSensors/aqiSensors.types';
import { LatLng } from 'shared/types';

type UseAQISensorProps = {
  id?: number;
};

type UseAQISensor = Omit<UseQueryResult<AQISensor, Error>, 'data'> & {
  aqiSensor?: AQISensor;
};

export type ServerAQISensor = {
  id: AQISensor['id'];
  name: AQISensor['name'];
  data: {
    aqi?: AQISensor['aqi'];
  };
  location: LatLng;
  isOffline: boolean;
};

const fetchAQISensor = async (
  aqiSensorId: number | string,
): Promise<AQISensor> => {
  const response = await API.get<ServerAQISensor>(
    `weather/station/${aqiSensorId}/`,
  );

  const { data, ...serverAQISensorRoot } = response.data;

  return {
    ...serverAQISensorRoot,
    ...data,
  };
};

export const useAQISensor = (props: UseAQISensorProps): UseAQISensor => {
  const { id } = props;

  const query = useQuery({
    queryKey: ['aqiSensor', id],
    queryFn: () => fetchAQISensor(id!),
    enabled: Boolean(id),
  });

  return {
    ...query,
    aqiSensor: query.data,
  };
};
